(() => {
  if (window.FPRopeSelector) return;

  function sync(section) {
    const selector = section?.querySelector('[data-fp-rope-selector]');
    if (!selector) return;
    const selected = selector.querySelector('[name="lado-corda"]:checked');
    const property = section.querySelector('product-form [name="properties[Lado da cordinha]"]');
    if (property) {
      property.value = selected?.value || '';
      property.disabled = !selected;
    }
    const debug = selector.querySelector('[data-fp-rope-debug]');
    if (debug) debug.textContent = selected ? `Lado selecionado: ${selected.nextElementSibling?.textContent.trim() || selected.value}` : 'Nenhum lado selecionado';
  }

  window.FPRopeSelector = { sync };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-fp-rope-selector] [name="lado-corda"]')) {
      sync(event.target.closest('.section-main-product'));
    }
  });
  document.addEventListener('fp:connected-product-swapped', () => {
    sync(document.querySelector('#MainContent .section-main-product'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(document.querySelector('#MainContent .section-main-product')), { once: true });
  else sync(document.querySelector('#MainContent .section-main-product'));
})();
